export const FULL_BATTERY_LEVEL = 100;
export const HIGH_BATTERY_LEVEL = 20;
export const NORMAL_BATTERY_UP_LEVEL = 20;
export const NORMAL_BATTERY_BOTTOM_LEVEL = 10;
export const LOW_BATTERY_LEVEL = 10;
export const EMPTY_BATTER_LEVEL = 0;

export enum OperationType {
  UpgradeImprovement = 'upgrade-improvement',
  UpgradeImprovementWithoutUnfreeze = 'upgrade-improvement-without-unfreeze',
  SpendEnergy = 'spend-energy',
  RechargeEnergy = 'recharge-energy',
}
